import { useCallback } from 'react'
import { updateThreadModel } from '@/services/chat/threadsApi'

export function useModelSelectionAction(m) {
  return useCallback((model) => {
    const id = m.displayThreadId
    if (!id) return
    m.setThreads((prev) => prev.map((thread) => thread.id === id ? { ...thread, model } : thread))
    void updateThreadModel(id, model).catch(() => {})
  }, [m])
}
